export enum ExchangeRateMode {
    Random = 'random',
    PlayerTurn = 'player_turn'
  }